/**
 * OrbPostMachinesWithTraitsPart1VisionSLOrbPostMachinesWithTraitsPart1VisionSLPage
 *
 * Page component for OrbPostMachinesWithTraitsPart1VisionSLOrbPostMachinesWithTraitsPart1VisionSLPage
 * Path: /sl/blog/machines-with-traits-part-1-vision
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbPostMachinesWithTraitsPart1VisionSLPostPageView as __OrbPostMachinesWithTraitsPart1VisionSLPostPageView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionSLPostPageView';
import { OrbPostMachinesWithTraitsPart1VisionSLPostAnalyticsView as __OrbPostMachinesWithTraitsPart1VisionSLPostAnalyticsView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbPostMachinesWithTraitsPart1VisionSLOrbPostMachinesWithTraitsPart1VisionSLPageProps {
  // Add any page-level props here
}

export function OrbPostMachinesWithTraitsPart1VisionSLOrbPostMachinesWithTraitsPart1VisionSLPage(_props: OrbPostMachinesWithTraitsPart1VisionSLOrbPostMachinesWithTraitsPart1VisionSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Stroji z lastnostmi: kako bo Orb spremenil prihodnost robotike","description":"Predstavljajte si svet, v katerem za pametno premikanje robota ne potrebujete na tisoče vrstic kode. Svet, v katerem vedenje stroja opišete tako, kot opisujete gibanje planetov po njihovih orbitah.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/blog/machines-with-traits-part-1-vision"},{"locale":"ar","path":"/ar/blog/machines-with-traits-part-1-vision"},{"locale":"sl","path":"/sl/blog/machines-with-traits-part-1-vision"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbPostMachinesWithTraitsPart1VisionSLPostPageView config={{ initPayload: __navState }} />
          <__OrbPostMachinesWithTraitsPart1VisionSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbPostMachinesWithTraitsPart1VisionSLOrbPostMachinesWithTraitsPart1VisionSLPage;
